import { isPlatformBrowser } from '@angular/common';
import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { z } from 'zod';

import { ContentAPIService } from '../content-api.service';

const RedirectSchema = z.object({
  destination_path: z.string().optional().nullable(),
});

@Injectable()
export class RedirectGuard implements CanActivate {
  private apiService = inject(ContentAPIService);
  private router = inject(Router);
  private platformId = inject(PLATFORM_ID);

  canActivate(route: ActivatedRouteSnapshot) {
    const statusCode = route.data.statusCode;

    if (statusCode === 404) {
      if (!isPlatformBrowser(this.platformId)) {
        return of(true);
      }
      return this.apiService.getUnparsedResources('redirect', { source_path: window.location.pathname }).pipe(
        map((result) => RedirectSchema.parse(result)),
        map(({ destination_path }) => {
          if (destination_path) {
            this.router.navigateByUrl(destination_path);
            return false;
          }
          return true;
        }),
        catchError(() => of(true))
      );
    }

    return of(true);
  }
}
